export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"format-detection","content":"telephone=no"},{"name":"description","content":"MusicMint - Free AI Song Generator: Create original music with lyrics, melody and backing tracks in minutes. Perfect for musicians, content creators and producers. Supports Pop, EDM, Hip-Hop and 20+ genres. Customize tempo, mood and structure - no music theory required."},{"name":"keywords","content":"instant music creator, AI beat maker, custom backing tracks, royalty-free AI music, professional music without experience, vocal melody generator, indie artist tools, content creator music solution, YouTube background music maker, TikTok music generator, podcast intro music creator, custom genre mixing, music collaboration platform, stem separation AI, voice-to-song converter"},{"property":"og:title","content":"MusicMint - AI Music Generation Platform"},{"property":"og:description","content":"MusicMint is a powerful AI music platform that helps you easily create original music, generate lyrics, create rap names, and manage your personal music library. No professional knowledge required."},{"property":"og:type","content":"website"},{"property":"og:url","content":"https://musicmint.ai"},{"property":"og:image","content":"https://musicmint.ai/images/ogimage.png"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:title","content":"MusicMint - AI Music Generation Platform"},{"name":"twitter:description","content":"Create original music with AI. Generate lyrics, melodies, rap names and manage your personal music library."},{"name":"twitter:image","content":"https://musicmint.ai/images/ogimage.png"},{"property":"og:locale","content":"en_US"},{"property":"og:site_name","content":"MusicMint"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"canonical","href":"https://musicmint.ai"},{"rel":"preload","href":"/images/logo.png","as":"image","fetchpriority":"high"}],"style":[],"script":[],"noscript":[],"htmlAttrs":{"lang":"en","class":"dark"}}

export const appPageTransition = {"name":"page","mode":"out-in","appear":true}

export const appLayoutTransition = {"name":"layout","mode":"out-in"}

export const appKeepalive = {"max":10}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appViewTransition = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true